export default "__VITE_ASSET__DkUTG1rG__"